import request from '@/utils/request'
import storage from 'store'
import { ACCESS_TOKEN } from '@/store/mutation-types'

const mimeMap = {
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  zip: 'application/zip'
}

export function downLoadZip (str, filename) {
  // 使用 request 实例，这样会自动应用加密逻辑
  // str 可能包含查询参数，如 '/tool/gen/batchGenCode?tables=zb_advertisement'
  // request 实例会自动处理 URL 中的查询参数加密
  request({
    method: 'get',
    url: str, // 直接使用相对路径，request 会自动添加 baseURL
    responseType: 'blob'
  }).then(res => {
    resolveBlob(res, mimeMap.zip)
  }).catch(error => {
    console.error('下载文件失败:', error)
  })
}
/**
 * 解析blob响应内容并下载
 * @param {*} res blob响应内容
 * @param {String} mimeType MIME类型
 */
export function resolveBlob (res, mimeType) {
  try {
  const aLink = document.createElement('a')
    // 确保 res.data 是 Blob 对象
    let blob
    if (res.data instanceof Blob) {
      blob = res.data
    } else {
      blob = new Blob([res.data], { type: mimeType })
    }
    
    // 从response的headers中获取filename
    let fileName = 'download.zip' // 默认文件名
    const contentDisposition = res.headers['content-disposition'] || res.headers['Content-Disposition']
    
    if (contentDisposition) {
      try {
        const patt = new RegExp('filename=([^;]+\\.[^\\.;]+);*')
        const decoded = decodeURI(contentDisposition)
        const result = patt.exec(decoded)
        if (result && result[1]) {
          fileName = result[1].replace(/"/g, '').trim()
        }
      } catch (e) {
        console.warn('解析文件名失败:', e)
      }
    }
    
  aLink.style.display = 'none'
  aLink.href = URL.createObjectURL(blob)
    aLink.setAttribute('download', fileName)
  document.body.appendChild(aLink)
  aLink.click()
    // 延迟清理，确保下载开始
    setTimeout(() => {
      URL.revokeObjectURL(aLink.href)
      document.body.removeChild(aLink)
    }, 100)
  } catch (error) {
    console.error('下载文件处理失败:', error)
    throw error
  }
}
